import React, { useState } from 'react';

interface LogoProps {
  className?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = 'h-10 w-auto', showText = true }) => {
  const [logoError, setLogoError] = useState(false);

  return (
    <div className="flex items-center gap-2">
      {!logoError ? (
        <img 
          src="/images/tri2fly-logo.png" 
          alt="Tri2Fly Logo" 
          className={className}
          onError={() => setLogoError(true)}
        />
      ) : (
        showText && (
          <span className="text-2xl font-bold">
            <span className="text-primary-500">Tri</span>
            <span className="text-accent-500">2</span>
            <span className="text-primary-500">Fly</span>
          </span>
        )
      )}
    </div>
  );
};

export default Logo;

